// import axios from "axios";
// import { getBaseURLforBackEnd  , getConfigAxios } from '@/utils.js'

export default {
    namespaced: true,
    state: {


       CBCWorkList : [],

       filter_date_selected_start : new Date() ,
       filter_date_selected_end : new Date(),
       
       filter_opdno : "",
       filter_opdname : "",
       filter_ownername : "",
       filter_patho_selected : null,
       filter_status_selected : null,
       filter_docKind_selected : null,
        
       filter_dateKindsSelected : 1, 
       dateKinds : [{"id":1 ,name:"Date Request"},{"id":2 ,name:"Date Result"}],
       isShowSearchByComp : false,
       resultSearchBy : {},


   

    //    filter_selected : {
    //                         date_selected : [],
    //                         patho_selected : null,
    //                         status_selected : null,
    //                         docKind_selected : null,
    //                         ownername: "",
    //                         opdno: "",
    //                         opdname:"",
    //                         first : 10,
    //                         skip : 0
    //                     } ,


    },

    getters: {
    },

    mutations: {


        
        
        setFilter_dateKindsSelected(state, filter_dateKindsSelected) {
            state.filter_dateKindsSelected  = filter_dateKindsSelected

        },


         
        setFilter_docKind_selected(state, filter_docKind_selected) {
            state.filter_docKind_selected  = filter_docKind_selected

        },
        
        
        setFilter_status_selected(state, filter_status_selected) {
            state.filter_status_selected  = filter_status_selected

        },


        setFilter_patho_selected(state, filter_patho_selected) {
            state.filter_patho_selected  = filter_patho_selected

        },


        setResultSearchBy(state, resultSearchBy) {
            state.resultSearchBy  = resultSearchBy

        },

        setIsShowSearchByComp(state, isShowSearchByComp) {
            state.isShowSearchByComp  = isShowSearchByComp

        },

        setFilter_ownername(state, filter_ownername) {
            state.filter_ownername  = filter_ownername

        },


        setFilter_opdname(state, filter_opdname) {
            state.filter_opdname  = filter_opdname

        },


        setFilter_opdno(state, filter_opdno) {
            state.filter_opdno  = filter_opdno

        },

        setFilter_date_selected_start(state, filter_date_selected_start) {
            state.filter_date_selected_start  = filter_date_selected_start

        },

        setFilter_date_selected_end(state, filter_date_selected_end) {
            state.filter_date_selected_end  = filter_date_selected_end

        },



        setCBCWorkList (state, CBCWorkList) {
            state.CBCWorkList  = CBCWorkList

        },
  


    },

    actions: {
 
         
     

    }
}